import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgNightShift = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15 20",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "nonzero",
			d: "M5 0C3.18 0 1.47.5 0 1.35 2.99 3.08 5 6.3 5 10s-2.01 6.92-5 8.65C1.47 19.5 3.18 20 5 20c5.52 0 10-4.48 10-10S10.52 0 5 0z"
		})
	})
});
export default SvgNightShift;
